var map = {
	"./arg.svg": 2337,
	"./aus.svg": 2338,
	"./bel.svg": 2339,
	"./bra.svg": 2340,
	"./can.svg": 2341,
	"./cmr.svg": 2342,
	"./crc.svg": 2343,
	"./cro.svg": 2344,
	"./den.svg": 2345,
	"./ecu.svg": 2346,
	"./eng.svg": 2347,
	"./esp.svg": 2348,
	"./fra.svg": 2349,
	"./ger.svg": 2350,
	"./gha.svg": 2351,
	"./irn.svg": 2352,
	"./jpn.svg": 2353,
	"./kor.svg": 2354,
	"./ksa.svg": 2355,
	"./mar.svg": 2356,
	"./mex.svg": 2357,
	"./ned.svg": 2358,
	"./pol.svg": 2359,
	"./por.svg": 2360,
	"./qat.svg": 2361,
	"./sen.svg": 2362,
	"./srb.svg": 2363,
	"./sui.svg": 2364,
	"./tun.svg": 2365,
	"./uru.svg": 2366,
	"./usa.svg": 2367,
	"./wal.svg": 2368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;